export default Object.freeze({
  PendingActivation: 1,
  PendingPayment: 2,
  Active: 3,
  PastDue: 4,
  Canceled: 5,
  Suspended: 6,
});
